import script from "./WhoWeAre.vue?vue&type=script&setup=true&lang=js"
export * from "./WhoWeAre.vue?vue&type=script&setup=true&lang=js"

import "./WhoWeAre.vue?vue&type=style&index=0&id=b6205e86&scoped=true&lang=css"

import exportComponent from "/home/runcloud1user/webapps/kurdos-vue/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.26_vue@3.5.26_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b6205e86"]])

export default __exports__